import api from '../api';
import createEntity from './createEntity';
const today = new Date();
const oneMonthBefore = new Date(today);
oneMonthBefore.setMonth(oneMonthBefore.getMonth() - 1);
const historyList = createEntity();

const state = {
    loading: true,
    history: {},
    isVideoPlaying: false,
    searchText: "",
    comment: "",
    sessionId: null,
    endDate: today,
    startDate: oneMonthBefore
};

const mutations = {

    setLoading(state, loading) {
        state.loading = loading;
    },
    setHistory(state, history) {
        state.history = history;
    },
    setVideoPlaying(state, playing) {
        state.isVideoPlaying = playing;
    },
    searchUser(state, event) {
        state.searchText = event;
    },
    updateComment(state, event) {
        state.comment = event.target.value;
    },
    setSessionId(state, sessionId) {
        state.sessionId = sessionId;
    },
    setStartDate(state, date) {
        state.startDate = date;
    },
    setEndDate(state, date) {
        state.endDate = date;
    },
    clearComment(state) {
        state.comment = '';
    }

};

const getters = {
    historyList(state, getters, rootState, rootGetters) {
        return getters["historyList/getAll"].filter(history => {
            if (state.searchText !== undefined) {
                return history.name ? history.name.toLowerCase().indexOf(state.searchText.toLowerCase()) != -1 : false;
            }
            return true;
        });
    },
    getPoseForTime(state) {
        return (time) => {
            if (state.history && state.history.steps) {
                let pose = state.history.steps.find((pose) => pose.time == time);
                return pose ? pose.steps : undefined;
            }
        }
    }
};

const actions = {

    async loadHistory({ commit, state }) {
        commit("setLoading", true);
        let data = await api.getWatchHistory(state.startDate, state.endDate);
        commit("historyList/load", data);
        commit("setLoading", false);
    },
    async loadSessionDetails({ commit }, sessionId) {
        commit("setLoading", true);
        const data = await api.getSessionDetails(sessionId);
        if (!data) {
            commit("setLoading", false);
            throw new Error('Unable to fetch details for this workout session.');
        }
        commit("setHistory", data);
        commit("setLoading", false);
    },
    async sendComment({ commit }) {
        if (!state.comment) {
            return;
        }
        await api.sendCommment({
            sessionId: state.sessionId,
            comments: state.comment,
            videoId: state.history.videoId,
            performedBy: state.history.performedUserId,
            performedOn: state.history.performedAt
        });
        commit('clearComment');
        return true;
    },
    async setStartDate({ commit, dispatch }, startDate) {
        commit("setStartDate", new Date(startDate))
        await dispatch('loadHistory');
    },
    async setEndDate({ commit, dispatch }, endDate) {
        commit("setEndDate", new Date(endDate));
        await dispatch('loadHistory');
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        historyList
    }
}
